module.exports = __webpack_public_path__ + "static/media/delayed.685065d1.svg";